export function sum(v: number[]): number {
  return v.reduce((x, y)=>x+y);
}

export function mean(v: number[]): number {
  const total = sum(v);
  const count = v.length;
  return total/count;
}

export function variance(v: number[]) {
  const allx2 = sum(v.map(x=>x*x));
  const mu = mean(v);
  const count = v.length;
  return allx2/count - mu*mu;
}

export function stddev(v: number[]) {
  return Math.sqrt(variance(v));
}